import { deserialize } from 'cerialize'

export class Addresses {
	@deserialize public region_names: string[]
	@deserialize public town_names: string[]
	@deserialize public street_names: string[]
}
